import './App.css';
import Header from './components/Header/Header';
import QuestionAnswer from './components/QuestionAnswer/QuestionAnswer';
import Shop from './components/Shop/Shop';

function App() {
  return (
    <div className="">
      <Header></Header>
      <Shop></Shop>
      <QuestionAnswer></QuestionAnswer>
    </div>
  );
}

export default App;
